import {
    StyledActionLabel,
    StyledActionMessageContent,
    StyledActionName,
    StyledMessageContent,
    StyledTime,
} from './styles'
import {NinchatBotIcon} from 'components/Icon/Icon'
import React from 'react'
import {UIMessageProps} from '../types'
import {useTranslation} from 'react-i18next'

const ActionMessage: React.FC<{message: UIMessageProps['message'], time: UIMessageProps['time']}> = ({
    message, time,
}) => {
    const {t} = useTranslation()

    const {target} = message ?? {}
    const {
        element, label, options,
    } = target ?? {}

    const isButtonAction = element === 'button'
    const isLinkAction = element === 'a'
    const isSelectAction = element === 'select'

    if (!isButtonAction && !isLinkAction && !isSelectAction) {
        return null
    }

    const selectedOptions = options?.filter((option) => option.selected) ?? []
    const labelText = isSelectAction
        ? selectedOptions?.length === 0
            ? t('nothing')
            : selectedOptions
                ?.map((option) => option.label)
                ?.join(', ')
        : label


    return (
        <StyledMessageContent>
            <StyledActionMessageContent>
                <StyledActionName>
                    <NinchatBotIcon size={16} />
                </StyledActionName>
                <StyledActionLabel>{labelText}</StyledActionLabel>
                <StyledTime>{time}</StyledTime>
            </StyledActionMessageContent>
        </StyledMessageContent>
    )
}

export default ActionMessage
